import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { Panel, Button, Col, Row, HelpBlock } from 'react-bootstrap';
import { FormActions, Input, Checkbox } from '../../../common/components/formControls';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, reset, initialize, loading, pristine, t, onSubmit }) => {
	const handleReset = () => {
		reset();
		setTimeout(() => handleSubmit());
	};

	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit(values => onSubmit({ ...values, isExport: false }))}>
					<Row>
						<Col sm={6}>
							<Field name='minNumberLessons' component={Input} type='text' label={t('LoyalChildrenReport_MinNumberLessons')} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='noLessonInActiveTerm' component={Checkbox} label={t('LoyalChildrenReport_NoLessonInActiveTerm')} normalize={(v) => { return !!v }} />
						</Col>
					</Row>
					<FormActions>
						<Button onClick={handleSubmit(values => onSubmit({ ...values, isExport: false }))} disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<Button onClick={handleSubmit(values => onSubmit({ ...values, isExport: true }))} disabled={loading} bsStyle='warning'>{t('Common_ExportToExcel')}</Button>
						<Button disabled={pristine || loading} onClick={handleReset}>{t('Common_Reset')}</Button>

					</FormActions>
					<HelpBlock>{t('Common_ExportHelpText')}</HelpBlock>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'loyalChildrenReportFilter' })(withTranslation()(Filter));